import './style.css'
const Util = window.Util;

/* ========================================================================== */

function List(options) {
	options = options || {};
	this.nodes = {};
	this.nodes.base = this.node = Util.nodefy('<div class="component list">');
	if (options.search !== false) {
		var searchHolder = Util.nodefy('<div class="search-holder">');
		searchHolder.appendChild(Util.nodefy('<i class="icon-search">'));
		this.nodes.searchInput = searchHolder.appendChild(Util.nodefy('<input class="search-input" placeholder="search">'));
		this.node.appendChild(searchHolder);
		this.nodes.searchInput.oninput = this.filter.bind(this);
	}
	this.nodes.list = this.node.appendChild(Util.nodefy('<div class="items">'));
	this.items = options.items || [];
	this.onselect = options.onselect || function () {};
	this.filter();
}

List.prototype.filter = function () {
	var result = [];
	var filter = this.nodes.searchInput ? this.nodes.searchInput.value : '';
	for (var i = 0; i < this.items.length; i++) {
		var item = this.items[i];
		var str = item.name;
		if (str.match(new RegExp(Util.escapeRegExp(filter), "i"))) {
			result.push(item);
		}
	}
	this.renderList(result);
};

List.prototype.renderList = function (items) {
	var self = this;
	this.nodes.list.innerHTML = '';
	for (var i = 0; i < items.length; i++) {
		var item = items[i];
		var el = Util.nodefy('<div class="item">');
		el.innerHTML = item.name;
		(function (el, item) {
			el.onclick = function () {
				self.onselect(el, item);
			}
		})(el, item);
		this.nodes.list.appendChild(el);
	}
};

/* ========================================================================== */

function Collapsible(options) {
	options = options || {};
	this.nodes = {};
	this.nodes.base = this.node = Util.nodefy('<div class="component collapsible">');
	this.nodes.inner = this.node.appendChild(Util.nodefy('<div class="inner">'));
	this.nodes.button = this.node.appendChild(Util.nodefy(options.btnHtml));
	this.nodes.button.onclick = function () {
		this.parentElement.classList.toggle('active');
	};
	if (options.innerHtml) {
		this.nodes.inner.innerHTML = options.innerHtml;
	}
	if (options.innerNode) {
		this.nodes.inner.appendChild(options.innerNode);
	}
	if (options.autoclose !== false) {
		this.nodes.base.classList.add('autoclose');
	}
	if (options.innerStyle) {
		for (var style in options.innerStyle) {
			if (!options.innerStyle.hasOwnProperty(style)) continue;
			this.nodes.inner.style[style] = options.innerStyle[style];
		}
	}
}

if (!window.COLLAPSIBLE_LOADED) {
	window.COLLAPSIBLE_LOADED = true;
	document.addEventListener('click', function(event) {
		if (!event.target.closest('.collapsible.autoclose')) {
			var els = document.querySelectorAll('.collapsible.autoclose');
			for (var i = 0; i < els.length; i++) {
				els[i].classList.remove('active');
			}
		}
	}, true);
}

/* ========================================================================== */

export { List, Collapsible }
